<button
  type="button"
  class="term-chip"
  [class.term-chip--selected]="selected"
  [disabled]="disabled"
  [attr.aria-pressed]="selected"
  (click)="onClick()"
>
  <span class="term-chip__label">{{ label }}</span>
  <span *ngIf="showPrice && amount" class="term-chip__price">{{ amount }}</span>
</button>
